import { render, staticRenderFns } from "./MultiplePhotoSelector.vue?vue&type=template&id=6b9fc324&scoped=true"
import script from "./MultiplePhotoSelector.vue?vue&type=script&lang=ts"
export * from "./MultiplePhotoSelector.vue?vue&type=script&lang=ts"
import style0 from "./MultiplePhotoSelector.vue?vue&type=style&index=0&id=6b9fc324&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9fc324",
  null
  
)

export default component.exports